"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationService = void 0;
const jquery_1 = __importDefault(require("jquery"));
/**
 * Servicio para manejar toda la lógica de validación del formulario.
 */
class ValidationService {
    constructor(formState) {
        this.formState = formState;
    }
    setupFormValidation(onSubmit) {
        this.addCustomValidationMethods();
        this.initializeFormValidator(onSubmit);
    }
    addCustomValidationMethods() {
        jquery_1.default.validator.addMethod('googlePlaceSelected', (value, element) => {
            if (!value)
                return false;
            return this.formState.addressSelected === true && this.formState.addressPlace !== null;
        }, 'Debe seleccionar una dirección de las sugerencias de Google Maps');
    }
    initializeFormValidator(onSubmit) {
        (0, jquery_1.default)('#formDatosClienteform').validate({
            rules: {
                contactName: { required: true },
                contactLastName: { required: true },
                Name: { required: true },
                documentType: { required: true },
                documentNumber: { required: true },
                PhoneNumber: {
                    required: true,
                    minlength: 9
                },
                Address: {
                    required: true,
                    googlePlaceSelected: true
                },
                Email: {
                    required: true,
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]+$/i
                },
                termsCheckbox: { required: true }
            },
            messages: {
                Address: {
                    required: 'Por favor, introduce una dirección',
                    googlePlaceSelected: 'Tienes que seleccionar una dirección de las sugerencias del Google Maps'
                },
                contactName: 'El nombre es obligatorio',
                contactLastName: 'Los apellidos son obligatorios',
                termsCheckbox: 'Debes aceptar los términos y condiciones para continuar'
            },
            errorPlacement: (error, element) => {
                if (element.attr('name') === 'termsCheckbox') {
                    error.insertAfter(element.parent());
                }
                // Mostrar mensaje de error solo para el campo de dirección
                if (element.attr('name') === 'Address') {
                    // Buscar el contenedor padre (div.d-flex)
                    const container = element.closest('.d-flex');
                    if (container.length) {
                        error.insertAfter(container);
                    }
                    else {
                        error.insertAfter(element);
                    }
                    error.addClass('invalid-feedback d-block text-danger mt-1');
                }
            },
            highlight: (element) => {
                (0, jquery_1.default)(element).addClass('is-invalid');
            },
            unhighlight: (element) => {
                (0, jquery_1.default)(element).removeClass('is-invalid');
            },
            submitHandler: (form) => {
                onSubmit(form);
            }
        });
        const initialDocType = (0, jquery_1.default)('#documentType').val();
        if (initialDocType) {
            this.updateDocumentValidation(initialDocType);
        }
    }
    updateDocumentValidation(documentType) {
        const $documentNumber = (0, jquery_1.default)('#documentNumber');
        $documentNumber.rules('remove');
        $documentNumber.rules('add', { required: true });
    }
}
exports.ValidationService = ValidationService;
